import { Component } from '@angular/core';
import  {environment}  from '../environments/environment';
import { Router, NavigationEnd } from '@angular/router';
declare const gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'copied';
  constructor(private router: Router){
    this.addGAScript();
      this.router.events.subscribe(event => {
        if(event instanceof NavigationEnd){
            gtag('event', 'page_view', 
                  {
                    page_path: event.urlAfterRedirects
                  }
             );
         }
      })
   }
  /** Add Google Analytics Script Dynamically */
 addGAScript() {
  let gmap: HTMLScriptElement = document.createElement('script');
  gmap.async = true;
  gmap.src = `https://maps.googleapis.com/maps/api/js?key=${environment.GOOGLE_MAP_KEY}`;
  document.head.prepend(gmap);
  if(environment.googleAnalytic ==='prod'){
  let gtagScript: HTMLScriptElement = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.googleAnalyticKey;
  document.head.prepend(gtagScript);
  gtag('config', environment.googleAnalytic, { send_page_view: false });
  }
}
}
